// eslint-disable-next-line no-unused-vars,camelcase
const img_url_prefix = 'http://img.qiestar.com/'
const shareUrlPrefix = 'http://client.dikaikeji.com/#/'

export function imageslimP(imgUrl) {
    // eslint-disable-next-line camelcase
    return `${img_url_prefix}${imgUrl}?imageslim`
}

export function imageslim(imgUrl) {
    if (!imgUrl || imgUrl === '') {
        return ''
    }
    return `${imgUrl}?imageslim`
}

export function imageThumbnail(imgUrl, width, needPrefix = false) {
    if (!imgUrl || imgUrl === '') {
        return ''
    }
    // eslint-disable-next-line camelcase
    return needPrefix ? `${img_url_prefix}${imgUrl}?imageView2/2/w/${width}` : `${imgUrl}?imageView2/2/w/${width}`
}

export function imageFullUrl(imgUrl) {
    // eslint-disable-next-line camelcase
    return `${img_url_prefix}${imgUrl}`
}

export function monthToAge(minMonth, maxMonth) {
    if (!minMonth || !maxMonth) {
        return ''
    }
    // eslint-disable-next-line camelcase
    const minYearAge = parseInt(minMonth / 12)
    const minMonthAge = minMonth % 12
    const minAge = `${minYearAge > 0 ? minYearAge + '岁' : ''}${minMonthAge > 0 ? minMonthAge + '个月' : ''}`
    const maxYearAge = parseInt(maxMonth / 12)
    const maxMonthAge = maxMonth % 12
    const maxAge = `${maxYearAge > 0 ? maxYearAge + '岁' : ''}${maxMonthAge > 0 ? maxMonthAge + '个月' : ''}`
    return `${minAge}-${maxAge}`
}

export function birthdayToAge(birthday) {
    if (!birthday) {
        return ''
    }
    const birthdayArr = birthday.split('-')
    const birthdayYear = birthdayArr[0]
    const birthdayMonth = birthdayArr[1]
    const birthdayDay = birthdayArr[2]
    var start = new Date()// 初始化输入时间
    var startYear = start.getFullYear()// 获取输入年份
    var startMonth = start.getMonth() + 1// 获取输入月份
    var startDay = start.getDate()// 获取输入日期

    var currentYear = birthdayYear// 获取当前年份
    var currentMonth = birthdayMonth// 获取当前月份
    var currentDay = birthdayDay// 获取当前日期
    var years = 0// 声明一个年数变量
    var months = startMonth - currentMonth + Math.abs(currentYear - startYear) * 12// 总月
    if (currentDay > startDay) {
        months--// 如果结束日期小月输入日期，月数要-1
    }
    years = Math.abs(Math.floor(months / 12))// 取整计算年数
    months = Math.abs(months % 12)// 取余计算月数
    var middleDate = new Date(start)// 中间时间
    middleDate.setFullYear(startYear + years)// 设置中间时间年份
    middleDate.setMonth(start.getMonth() + months)// 设置中间时间月份
    // var days = Math.abs(Math.floor((currentDay - middleDate.getDate())))// 计算天数
    const yearAge = `${years > 0 ? years + '岁' : ''}`
    const monthAge = `${months > 0 ? months + '个月' : ''}`
    // const dayAge = `${days > 0 ? days + '天' : ''}`
    return `${yearAge}${monthAge}`
}

export function isIosClient() {
    return false
    // let ua = navigator.userAgent.toLowerCase()
    // return /(iPhone|iPad|iPod|iOS)/i.test(ua)
}

export function shareUrlFull(pageUrl) {
    return `${shareUrlPrefix}/${pageUrl}`
}

export function isTokenExist() {
    return localStorage.getItem("token")
}

export function saveToken(token) {
    localStorage.setItem("token", token)
}
